export const locationMap = [ function () {
    return {
        link: function($scope, $elem, $attrs) {
            // console.log('building map');

            var map = new google.maps.Map($elem[0], {
                center: {lat: -34.397, lng: 150.644},
                scrollwheel: false,
                zoom: 15,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_TOP
                },
                scaleControl: false,
                mapTypeControl: false,
                streetViewControl: false
            });

            var markers = JSON.parse($attrs.markers);

            var bounds = new google.maps.LatLngBounds();

            var infowindow = new google.maps.InfoWindow();

            // Add markers to the map
            for(var i = 0; i < markers.length; i++){

                var marker = new google.maps.Marker({
                    map: map,
                    draggable: false,
                    animation: google.maps.Animation.DROP,
                    position: markers[i],
                    icon: richman_app_vars['theme_uri']+'/img/ic_place_black_24px.svg',
                });
                var pos = new google.maps.LatLng(markers[i]);

                bounds.extend( pos );

                (function(m, details){
                    console.log('details', details);
                    google.maps.event.addListener(m, 'click', function(event) {
                        infowindow.setContent(`<div>
                            <div>
                                <a href="${details.url}"><strong>${details.name}</strong></a>
                            </div>
                            <div>
                                <a href="${details.url}">View Property</a>
                            </div>
                        </div>`);
                        // infowindow.setPosition(event.latLng)
                        infowindow.open(map, m);
                    });
                }(marker, markers[i] ));
            }

            map.fitBounds(bounds);

            google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
                var zoom = map.getZoom();
                if(zoom > 12){
                    map.setZoom(12)
                }
                else{
                    map.setZoom( zoom - 1 );
                }
            });


        }
    }
}]